import { Dispatch } from 'redux'

import { getAllFilterOptions } from 'redux/api/KPITemplates'

import * as actions from './actions'

export function tryGetAllFilterOptions(dispatch: Dispatch) {
  getAllFilterOptions()
    .then((response) => {
      dispatch(actions.getAllSuccess(response.data.data))
    })
    .catch(() => {})
}
